export const EMPTY_USER_FILTERS = {
  search: '',
  role: 'all',
  status: 'all',
  siteId: 'all',
};

const normalize = (value) => String(value ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLocaleLowerCase();

export const filterUsers = (users, filters, sites = []) => {
  const normalizedSearch = normalize(filters.search).trim();

  return users.filter((user) => {
    const site = sites.find((candidate) => String(candidate.id) === String(user.site_id));
    const searchableText = normalize([
      user.username,
      user.email,
      site?.code,
      site?.name,
    ].join(' '));

    if (normalizedSearch && !searchableText.includes(normalizedSearch)) return false;
    if (filters.role !== 'all' && user.role !== filters.role) return false;
    if (filters.status === 'active' && !user.active) return false;
    if (filters.status === 'inactive' && user.active) return false;
    if (filters.siteId !== 'all' && String(user.site_id) !== String(filters.siteId)) return false;

    return true;
  });
};
